<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.announcements')">Announcement</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.title" :errors="$page.props.errors.title" class="pr-6 pb-8 w-full lg:w-1/2" label="Title" />
        </div>

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.start_date" :errors="$page.props.errors.start_date" class="pr-6 pb-8 w-full lg:w-1/2" label="Start Date" type="date" />
<!--          <text-input v-model="form.start_time" :errors="$page.props.errors.start_time" class="pr-6 pb-8 w-full lg:w-1/2" label="Start Time" type="time" />-->

          <text-input v-model="form.end_date" :errors="$page.props.errors.end_date" class="pr-6 pb-8 w-full lg:w-1/2" label="End Date" type="date" />
<!--          <text-input v-model="form.end_time" :errors="$page.props.errors.end_time" class="pr-6 pb-8 w-full lg:w-1/2" label="End Time" type="time" />-->
        </div>


        <div class="p-8 -mr-6 -mb-8 flex flex-wrap items-center">
          <toggle v-model="form.show_until_dismissed" />
          <span class="ml-4">Enable to allow customer to dismiss the notice</span>
        </div>

        <div class="p-8 mb-8">
          <div class="py-4">Announcement Body</div>
          <wysiwyg v-model="form.body" class="prose" />
        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-end items-center">
          <loading-button :loading="sending" class="btn-primary" type="submit">Publish Announcement</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import Toggle from '../../../Shared/Toggle'

export default {
  metaInfo: { title: 'Create Announcement' },
  layout: Layout,
  components: {
    Toggle,
    LoadingButton,
    SelectInput,
    TextInput
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        title: null,
        body: null,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        show_until_dismissed: false
      },
    }
  },
  methods: {
    submit() {
      this.sending = true
      this.$inertia.post(this.route('manage.announcements.store'), this.form,{
        onFinish : () => this.sending = false
      })
    },
  },
}
</script>
